module.exports = __webpack_public_path__ + "img/kuwait.52979ff1.png";